import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { RootState } from "@/store/store";
import styles from "./css/ProjectsPage.module.css";
import { SearchInput } from "@/components/inputFields/SearchInput";
import { EntityInfoSection } from "@/components/pageParts/cityView/EntityInfoSection";
import { ProjectCard } from "@/components/cards/ProjectCard";
import { getEntityIdPair } from "@/utils/getEntityPairId";
import { useParams, useNavigate } from "react-router-dom";
import { Project } from "@/types/project";
import { Button } from "@/components/Buttons/Button";
import { BuildingsIcon } from "@/icons/BuildingsIcon";
import { useGetAllProjects } from "@/hooks/project/useGetAllProject";
import { setProjects } from "@/store/projectsSlice";
import { BackButton } from "@/components/Buttons/BackButton";
import { MapMenu } from "@/components/menus/MapMenu";
import { GIS } from "@/GIS/GIS";

export const ProjectsPage: React.FC = () => {
    const { t } = useTranslation('ProjectsPage');
    const dispatch = useDispatch();
    let {cityId} = useParams();
    const navigate = useNavigate();
    const user = useSelector((state: RootState) => state.user.user);
    const {entityName} = useParams<{entityName: string}>();
    const fetchedProjects = useSelector((state: RootState) => state.projects.projects);
    const city = useSelector((state: RootState) => state.entity.userCity) || useSelector((state: RootState) => state.entity.cities.find(city => city.id === cityId)) || null;
    const ao = useSelector((state: RootState) => state.entity.userAo);
    const entityType = useSelector((state: RootState) => state.entity.entityType);
    const [resultProjects, setResultProjects] = useState<Project[]>(fetchedProjects || []);
    const [selectedProject, setSelectedProject] = useState<Project | null>(null);

    if(!cityId && city?.id){
        cityId = city?.id;
    }
    const getAllProjects = useGetAllProjects({
        onSuccess(data) {
            setResultProjects(data);
            dispatch(setProjects(data));
        },
        onError(error) {
            console.error("Error in get all projects");
        }
    });

    useEffect(() => {
        setResultProjects(fetchedProjects || []);
    }, [fetchedProjects]);

    useEffect(() => {
        let body = getEntityIdPair(entityType, city, ao);
        if("ao_id" in body && (!city || !cityId)){
            navigate(`/404`);
        }
        if (cityId){
            body["city_id"] = cityId;
        }
        getAllProjects.mutate(body);
    }, []);

    const filterProjects = (searchText: string, projects: Project[]) => {
        let filteredProjects = projects;
        let textSplitted = searchText.split(" ");
        textSplitted.forEach(text => {
            filteredProjects = filteredProjects.filter(project => 
                project.name.toLowerCase().includes(text.toLowerCase()) || 
                project.block?.toLowerCase().includes(text.toLowerCase()) || 
                project.plot?.toLowerCase().includes(text.toLowerCase())
            );
        });
        return filteredProjects;
    }

    const handleSelectProject = (project: Project | null) => {
        setSelectedProject(project);
    }
    
    return (
        <>
        <div className={styles.container}>
            <div className={styles.header}>
                {city && <EntityInfoSection entity={city}/>}
                {entityType === "ao" && <BackButton onClick={() => {navigate(`/${entityName}/cities`)}}/>}
            </div>
            <div className={styles.content}>
                <SearchInput id="search" placeholder="חפש פרוייקט לפי גוש חלקה / שם" size="full" options={resultProjects} onSelect={handleSelectProject} filterFunction={filterProjects}/>
                <div className={styles.row}>
                    <div className={styles.projectsView}>
                            <div>
                                <Button 
                                    iconComponent={BuildingsIcon} 
                                    size="large"
                                    icon={"right-side"} 
                                    text="צור פרויקט חדש" 
                                    id="addProject" 
                                    onClick={() => {navigate(`/${entityName}/projects/create/${cityId}`)}}
                                    className={styles.fullWidthButton}
                                />
                            </div>
                        <div className={styles.cardsContainer}>
                            {selectedProject ? resultProjects.filter(project => project.id === selectedProject.id).map((project) => (
                                <ProjectCard key={`${project.id}-${Math.random()}`} project={project}/>
                            )) : resultProjects.map((project) => (
                                <ProjectCard key={`${project.id}-${Math.random()}`} project={project}/>
                            ))}
                        </div>
                    </div>
                    <div className={styles.mapContent}>

                        {city && <GIS city={city} office={ao || undefined} onFeatureClick={() => {alert("clicked")}}></GIS>}

                    </div>
                </div>
            </div>
        </div>
        </>
    );
}
